module.exports = {
  title: 'Gooey Delete Button with React Native Skia',
  author: 'Enzo Manuel Mangano',
  date: '2024-10-08',
  slug: 'delete-button',
  tags: ['skia'],
};
